import { MDBIcon } from "mdb-react-ui-kit";
import { useContext } from 'react';
import useResumeLanguageSkillsHandlers from "../../../context/resume/hooks/resume-language-skills-handlers";
import { TranslationContext } from "../../../context/translations/translations-context";

export default function AddLanguageSkill() {

    const { translations } = useContext( TranslationContext );
    const { handleAdd } = useResumeLanguageSkillsHandlers();

    return (
        <button className="btn_primary" onClick={ handleAdd }>
            <MDBIcon fas icon="plus-circle" color='light' size='sm'/>
            <span className='ms-1'>{ translations.languageSkillsSection.addLanguageLabel }</span>
        </button>
    )
}
